import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { colors, screens } from './common/constants';

export const StyledBooking = styled(Container)`
  color: ${colors.primary};
  flex: 1;
  padding: 32px 4px;
  background-color: #fff;
  display: flex;
  align-items: center;
`;
StyledBooking.displayName = 'StyledBooking';

export const BookingTitle = styled.div`
  text-align: center;
  font-weight: bold;
  padding-top: 8px;
  padding-bottom: 8px;
  text-transform: uppercase;
  font-size: 2rem;
`;
